import { useState, useEffect, useRef } from 'react';
import { Button } from 'primereact/button';
import './RecipeHistoryView.scss';
import { initialStatePhoneNumber, InputPhone, InputTextCustom, mobilePhoneToString, Modal, validMobileForInputPhone, WindowLoader } from 'medere-ui-framework';
import { Icon } from '@iconify/react';
import PendingRecipeTab from './Tabs/PendingRecipeTab';
import RecipeHistoryTab from './Tabs/RecipeHistoryTab';
import { ERecipeHistoryTab, ESteps, ERecipeViews, ETaskMessageType } from '../RecipeEnums';
import { defaultProfessional, Medicine, PatientRecordDTO, Professional, FileDTO, RequestedPrescriptions, ScheduleMessageResponseDTO, UserAllowedToPrescript } from '../../../interface/interface';
import { copyDigitalRpById, hasSenderPermissionByTaskMessageTypeAndMessageType, loadProfessionalByMedereEntity, savePatient, sendDigitalRpByMessageSender } from '../../../servicesHooks/DigitalRP/useDigitalRPService';
import { EMessageType } from '../RecipeEnums';
import PdfViewer from '../Components/PdfViewer';
import { Toast, ToastMessage } from 'primereact/toast';
import { validateInternationalCellphone } from '../../../utils/utils';
import { customerServiceNumber, whatsappPurchaseText } from '../../../utils/Constants';

export default function RecipeHistoryView(params: { allProfileDataFilled: boolean, activeView: number, setActiveView: (av: any) => void, subActiveView: number | undefined, setSubActiveView: (av: number | undefined) => void, prevActiveView: number | undefined, setPrevActiveView: (pav: number | undefined) => void, prevSubActiveView: number | undefined, setPrevSubActiveView: (pav: number | undefined) => void, medications: Medicine[] | null, setMedications: (medicine: Medicine[] | null) => void, selectedPatient: PatientRecordDTO | null, setSelectedPatient: (patient: PatientRecordDTO | null) => void, setProlongedTreatment: (prolonged: boolean) => void, setHidePatientData: (hiding: boolean) => void, professional: Professional, pendingRecipes: RequestedPrescriptions[] | null | undefined, setPendingRecipes: (recipe: RequestedPrescriptions[] | null | undefined) => void, setRequestPrescription: (recipe: number) => void, setGoToMedicationStep: (goto: boolean) => void, setProfessional: (professional: Professional) => void, handleToggleCard: (r: RequestedPrescriptions) => void, openCard: number | null, setOpenCard: (soc: number) => void, secretary: UserAllowedToPrescript | null }) {
    const { allProfileDataFilled, activeView, setActiveView, subActiveView, setSubActiveView, prevActiveView, setPrevActiveView, prevSubActiveView, setPrevSubActiveView, medications, setMedications, selectedPatient, setSelectedPatient, setProlongedTreatment, setHidePatientData, professional, pendingRecipes, setPendingRecipes, setRequestPrescription, setGoToMedicationStep, handleToggleCard, openCard, setOpenCard, secretary } = params;
    const setProfessional = params.setProfessional
    const toast = useRef(null)
    const [patientInput, setPatientInput] = useState('');
    const [sendModalVisible, setSendModalVisible] = useState(false);
    const [disabledWhatsapp, setDisabledWhatsapp] = useState<boolean>(true);
    const [usedefaultcontact, setUseDefaultContact] = useState<boolean>(false);
    const [defaultEmail, setUseDefaultEmail] = useState<string>(selectedPatient?.email ?? '');
    const [defaultMobilePhone, setUseDefaultMobilePhone] = useState<string>(selectedPatient?.mobilephone ?? '');

    const [disabledEmail, setDisabledEmail] = useState<boolean>(true);
    const [openEditMobilephoneModal, setOpenEditMobilephoneModal] = useState(false);
    const [newMobilephone, setNewMobilephone] = useState('');
    const [openEditMailModal, setOpenEditMailModal] = useState(false);
    const [newMail, setNewMail] = useState('');
    const [cancelModalVisible, setCancelModalVisible] = useState(false);
    const [activeTab, setActiveTab] = useState(subActiveView && subActiveView !== 0 ? subActiveView : ERecipeHistoryTab.PENDING);
    const [digitalRpId, setDigitalRpId] = useState<number | null>(null)
    const [digitalRpFiles, setDigitalRpFiles] = useState<FileDTO | null>(null)
    const [sentRecipe, setSentRecipe] = useState(false)
    const [datePrescribed, setDatePrescribed] = useState<Date>(new Date())
    const [paddingTop, setPaddingTop] = useState('65%');
    const [isMobile, setisMobile] = useState(window.innerWidth < 700)
    const [loading, setLoading] = useState(false);

    const [patientPhone, setPatientPhone] = useState(initialStatePhoneNumber);

    const showMessage = (ref: React.RefObject<Toast>, msg: any, severity: ToastMessage['severity']) => {
        ref.current?.show({ severity: severity, summary: msg, life: 3000 });
    };



    useEffect(() => {
        const computePaddingTop = () => { //padding para las modales
            const minWidth = 430;
            const maxWidth = 1024;
            const minPadding = 20;
            const maxPadding = 50;
            const windowWidth = window.innerWidth;

            if (windowWidth <= minWidth) {
                setPaddingTop(`${maxPadding}%`);
            } else if (windowWidth >= maxWidth) {
                setPaddingTop(`${minPadding}%`);
            } else {
                const padding = maxPadding - ((windowWidth - minWidth) / (maxWidth - minWidth)) * (maxPadding - minPadding);
                setPaddingTop(`${padding}%`);
            }
        };

        computePaddingTop();
        const handleResize = () => {
            setisMobile(window.innerWidth < 700);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        const fetchPermission = async () => {
            try {
                await hasSenderPermissionByTaskMessageTypeAndMessageType(EMessageType.WHATSAPP, ETaskMessageType.RECIPES)
                    .then((res) => {
                        setDisabledWhatsapp(!res.hassenderpermission)
                        setUseDefaultContact(res.usedefaultcontact)
                        if (res.usedefaultcontact) {
                            setUseDefaultEmail(res.defaultemail)
                            setUseDefaultMobilePhone(res.defaultmobilephone)
                        }
                    })
                await hasSenderPermissionByTaskMessageTypeAndMessageType(EMessageType.EMAIL, ETaskMessageType.RECIPES)
                    .then((res) => {
                        console.log('Mensajería por defecto: ', res)
                        setDisabledEmail(!res.hassenderpermission)
                        setUseDefaultContact(res.usedefaultcontact)
                        if (res.usedefaultcontact) {
                            setUseDefaultEmail(res.defaultemail)
                            setUseDefaultMobilePhone(res.defaultmobilephone)
                        }
                    })
            } catch (error) {
                console.error(error);
            }
        };

        fetchPermission();
    },);

    useEffect(() => {
        if (!openEditMailModal)
            setNewMail('')
    }, [openEditMailModal])

    useEffect(() => {
        if (!openEditMobilephoneModal)
            setNewMobilephone('')
    }, [openEditMobilephoneModal])

    const renderTabContent = () => {
        if (activeTab === ERecipeHistoryTab.PENDING) {
            return <PendingRecipeTab allProfileDataFilled={allProfileDataFilled} setMedications={setMedications} setSelectedPatient={setSelectedPatient} pendingRecipes={pendingRecipes} setPendingRecipes={setPendingRecipes} setRequestPrescription={setRequestPrescription} professional={professional} patientInput={patientInput} setGoToMedicationStep={setGoToMedicationStep} handleToggleCard={handleToggleCard} openCard={openCard} setOpenCard={setOpenCard} secretary={secretary} />;
        } else {
            return <RecipeHistoryTab setOpenSendModal={setSendModalVisible} setDigitalRpId={setDigitalRpId} setDigitalRpFiles={setDigitalRpFiles} setSelectedPatient={setSelectedPatient} professional={professional} patientInput={patientInput} setProfessional={setProfessional} datePrescribed={datePrescribed} setDatePrescribed={setDatePrescribed} />;
        }
    };

    const sendDigitalRP = async (messageType: number) => {
        if (messageType === EMessageType.WHATSAPP) {
            const number = selectedPatient?.mobilephone;
            if (!number) {
                showMessage(toast, 'Debe ingresar un número de celular.', 'error');
                setLoading(false);
                return;
            }

            const validation = validateInternationalCellphone(number);
            if (!validation.isValid()) {
                showMessage(toast, validation.errorMessage, 'error');
                setLoading(false);
                return;
            }
        }
        setLoading(true)
        await sendDigitalRpByMessageSender({
            messageTypeId: messageType,
            digitalRpFiles: [digitalRpFiles],
            patientId: selectedPatient?.medereentity ?? -1,
            professionalId: professional.professionaid,
            digitalRpId: null
        }).then((res: ScheduleMessageResponseDTO) => {
            if (res.success) {
                showMessage(toast, 'Receta enviada correctamente al paciente', 'success')
                setSentRecipe(true) //en handleRemoveToast se cierra la ventana
            }
            else
                showMessage(toast, res.message, 'error')
        }).catch((err) => {
            console.error('Error enviando Rp:', err);
            if (err.response?.status === 400) {
                showMessage(toast, 'Asegurate de escribir el celular en formato internacional (ej: +54 2231234567).', 'error');
            } else {
                showMessage(toast, 'Ocurrió un error en el envío', 'error');
            }
        })
        setLoading(false)
    }

    const handleOpenEditMobilephoneModal = () => {
        if (selectedPatient?.mobilephone) {
            const parsedPhone = validMobileForInputPhone(selectedPatient.mobilephone);
            setPatientPhone(parsedPhone);
            setNewMobilephone(selectedPatient.mobilephone);
        } else {
            setPatientPhone(initialStatePhoneNumber);
            setNewMobilephone('');
        }
        setOpenEditMobilephoneModal(true);
    };

    const handleOpenEditMailModal = () => {
        if (selectedPatient?.email)
            setNewMail(selectedPatient.email)
        setOpenEditMailModal(true)
    }

    const handleNewRecipe = () => {
        setSelectedPatient(null),
            setSubActiveView(ESteps.PATIENTSTEP),
            setActiveView(ERecipeViews.NEWRECIPE)
    }

    const handleDownloadPdfs = () => {
        const byteCharacters = atob(digitalRpFiles?.encodedPdf ?? '');
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);

        const blob = new Blob([new Uint8Array(byteArray)], { type: 'application/pdf' });

        const url = URL.createObjectURL(blob);

        window.open(url, '_blank');
    };

    const handleShare = async () => {
        try {
            // Convierte la cadena de bytes en un ArrayBuffer
            const byteCharacters = atob(digitalRpFiles?.encodedPdf ?? '');
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);

            // Crea un Blob con el ArrayBuffer
            const blob = new Blob([byteArray], { type: 'application/pdf' });

            // Crea un archivo a partir del Blob
            const filesToShare = [new File([blob], 'receta.pdf', { type: 'application/pdf' })];


            if (navigator.canShare && navigator.canShare({ files: filesToShare })) {
                await navigator.share({
                    files: filesToShare,
                    title: 'Receta Médica',
                    text: 'Aquí está tu receta médica en formato PDF.',
                });
                console.log('Archivo(s) compartido(s) con éxito');
            } else {
                alert('La función de compartir archivos no está disponible en este navegador.');
            }
        } catch (error) {
            console.error('Error al compartir:', error);
        }
    };

    const handleRemoveToast = () => {
        if (sentRecipe) {
            setSentRecipe(false)
            setSendModalVisible(false) //va al useEffect de sendModal, que limpia todo y vuelve al dashboard
        }
    }

    const notPrescriptionInEffect = () => {

        // Convierte datePrescribed a Date si no lo es
        const validDate =
            datePrescribed instanceof Date ? datePrescribed : new Date(datePrescribed);

        if (isNaN(validDate.getTime())) {
            console.error("datePrescribed no es una instancia válida de Date");
            return false;
        }

        const vigencia = new Date(validDate);
        vigencia.setDate(vigencia.getDate() + 30);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        vigencia.setHours(0, 0, 0, 0);

        return vigencia < today;
    };



    return (
        <div className="recipe-history-view">
            {isMobile ?
                <div>
                    <div style={{ paddingLeft: '15px', paddingRight: '15px', paddingTop: '15px' }}>
                        <h1 style={{ marginLeft: '8px', marginTop: '8px', fontWeight: 600 }}>Historial de recetas</h1>
                        <div style={{ marginLeft: '8px', marginTop: '15px' }} className="patient-search-container">
                            <InputTextCustom
                                className={`patient-input ${patientInput ? 'active' : ''} border-grey`}
                                value={patientInput}
                                onChange={(e) => setPatientInput(e.target.value)}
                                placeholder="Buscar paciente"
                            />
                            <i className="pi pi-search patient-search-icon"></i>
                        </div>
                        <div className="tab-container gap-2" style={{ marginTop: '15px', paddingLeft: '12px' }}>
                            <div
                                className={`tab ${activeTab === ERecipeHistoryTab.PENDING ? 'active' : ''}`}
                                onClick={() => setActiveTab(ERecipeHistoryTab.PENDING)}
                            >
                                Pendientes
                            </div>
                            <div
                                className={`tab ${activeTab === ERecipeHistoryTab.FINISHED ? 'active' : ''}`}
                                onClick={() => setActiveTab(ERecipeHistoryTab.FINISHED)}
                            >
                                Realizadas
                            </div>
                        </div>
                        <div style={{ marginTop: '10px' }} className="cards-container">
                            {renderTabContent()}
                        </div>
                    </div>
                    <div style={{ boxShadow: '0px -4px 16px 0px rgba(0, 0, 0, 0.15)' }}>
                        <div style={{ paddingLeft: '15px', paddingRight: '15px', paddingTop: '12px', marginLeft: '10px', display: 'flex', flexDirection: 'column' }}>
                            <Button
                                icon={<Icon icon='vaadin:pills' style={{ fontSize: '25px', display: 'inline', marginRight: '10px', marginBottom: '4px', color: 'white' }} />}
                                label={"NUEVA RECETA"}
                                onClick={handleNewRecipe}
                                style={{ display: 'block', boxShadow: '0px 3px 12px -1px rgba(28, 52, 84, 0.26)', marginTop: '8px', backgroundColor: allProfileDataFilled ? '#3CB8BA' : '#878787', border: 'none', height: '36px' }}
                                disabled={!allProfileDataFilled}
                            />
                        </div>
                    </div>
                </div>
                :
                <div>
                    <div style={{ paddingLeft: '15px', paddingRight: '15px', paddingTop: '15px' }}>
                        <h1 style={{ marginLeft: '8px', marginTop: '8px', fontWeight: 600 }}>Historial de recetas</h1>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                            <div style={{ marginLeft: '8px' }} className="patient-search-container">
                                <InputTextCustom
                                    className={`patient-input ${patientInput ? 'active' : ''} border-grey`}
                                    value={patientInput}
                                    onChange={(e) => setPatientInput(e.target.value)}
                                    placeholder="Buscar paciente"
                                    style={{ width: '400px' }}
                                />
                                <i className="pi pi-search patient-search-icon"></i>
                            </div>
                            <div style={{ paddingRight: '15px', paddingTop: '5px' }}>
                                <Button
                                    className='btnRpContinue'
                                    icon={<Icon icon='vaadin:pills' style={{ fontSize: '20px', position: 'absolute', color: 'white', left: '15px' }} />}
                                    label={"NUEVA RECETA"}
                                    onClick={handleNewRecipe}
                                    style={{ width: '190px', paddingLeft: '40px', boxShadow: '0px 3px 12px -1px rgba(28, 52, 84, 0.26)', backgroundColor: allProfileDataFilled ? '#3CB8BA' : '#878787', border: 'none', height: '36px' }}
                                    disabled={!allProfileDataFilled}
                                />
                            </div>
                        </div>

                        <div className="tab-container gap-2" style={{ marginTop: '15px', paddingLeft: '12px' }}>
                            <div
                                className={`tab ${activeTab === ERecipeHistoryTab.PENDING ? 'active' : ''}`}
                                onClick={() => setActiveTab(ERecipeHistoryTab.PENDING)}
                            >
                                Pendientes
                            </div>
                            <div
                                className={`tab ${activeTab === ERecipeHistoryTab.FINISHED ? 'active' : ''}`}
                                onClick={() => setActiveTab(ERecipeHistoryTab.FINISHED)}
                            >
                                Realizadas
                            </div>
                        </div>
                        <div style={{ marginTop: '10px' }} className={"cards-container-desktop"}>
                            {renderTabContent()}
                        </div>
                    </div>
                </div>
            }

            {isMobile ?
                <div>
                    <Modal
                        visible={sendModalVisible}
                        setVisible={setSendModalVisible}
                        header={
                            <label style={{ fontSize: '22px', color: '#B67345' }}>
                                {notPrescriptionInEffect() ? 'Receta vencida' : 'Receta realizada'}
                            </label>}
                        headerStyle={{ paddingTop: '3px' }}
                        closable={false}
                        className="h-full"
                    >
                        <div className="modal-body">
                            <PdfViewer fileList={[digitalRpFiles?.encodedPdf ?? '']} />

                            <div style={{ display: 'flex', flexDirection: 'column', marginTop: '1rem' }}>
                                {notPrescriptionInEffect() && (
                                    <div
                                        style={{
                                            fontSize: '16px',
                                            color: 'rgb(30, 30, 30)',
                                            marginBottom: '1rem',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            lineHeight: '1.5',
                                        }}>
                                        <span style={{ fontWeight: 'bold' }}>
                                            Esta receta médica se encuentra vencida.
                                        </span>
                                        <span style={{ color: 'rgba(30,30,30,0.8)', fontWeight: 'normal' }}>
                                            Podés repetirla o generar una nueva para continuar con el proceso.
                                        </span>
                                    </div>
                                )}
                                <Button
                                    label={"Repetir"}
                                    className='font-size-sendButton'
                                    onClick={() => {
                                        if (digitalRpId)
                                            copyDigitalRpById(digitalRpId)
                                                .then((res) => {
                                                    setMedications(res.medications)
                                                    setProlongedTreatment(res.prolongedtreatment ? res.prolongedtreatment : false)
                                                    setHidePatientData(res.hidepatientdata ? res.hidepatientdata : false)

                                                    setPrevSubActiveView(ERecipeHistoryTab.FINISHED)
                                                    setPrevActiveView(activeView)

                                                    setSubActiveView(ESteps.MEDICATIONSTEP)
                                                    setActiveView(ERecipeViews.NEWRECIPE)
                                                })
                                        else
                                            console.error('digitalRpId undefined')
                                    }}
                                    style={{ backgroundColor: '#FFFFFF', color: '#292929', marginBottom: '10px', borderColor: '#3CB8BA' }}
                                    disabled={!allProfileDataFilled}
                                />
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                                    <Button
                                        icon={<Icon icon='bi:chat' style={{ color: disabledWhatsapp ? '#A8A8A8' : '#3CB8BA', marginRight: '10px', fontSize: '18px' }} />}
                                        label={"Por whatsapp a " + (usedefaultcontact ? defaultMobilePhone : (selectedPatient?.mobilephone ? selectedPatient.mobilephone : ''))}
                                        className='font-size-sendButton'
                                        onClick={() => { sendDigitalRP(EMessageType.WHATSAPP) }}
                                        style={{ backgroundColor: '#FFFFFF', color: '#292929', textAlign: 'left', flexGrow: 1, borderColor: '#3CB8BA' }}
                                        disabled={disabledWhatsapp || !selectedPatient?.mobilephone || notPrescriptionInEffect()}
                                    />
                                    <Button
                                        icon={<Icon icon={selectedPatient?.mobilephone ? 'bi:pencil-square' : 'bi:plus'} style={{ color: '#01717C', fontSize: selectedPatient?.mobilephone ? '19px' : '24px' }} />}
                                        onClick={handleOpenEditMobilephoneModal}
                                        style={{ backgroundColor: '#FFFFFF', color: '#01717C', borderColor: '#3CB8BA', borderRadius: '4px', marginLeft: '10px', padding: '6px 1px', display: 'flex', alignItems: 'center', justifyContent: 'center', minWidth: '40px' }}
                                        disabled={disabledWhatsapp || usedefaultcontact}
                                    />
                                </div>
                                {disabledWhatsapp && (
                                    <small style={{ color: '#FFB400', display: 'block', marginTop: '-5px', marginBottom: '5px', textAlign: 'right' }}>
                                        <i className="pi pi-exclamation-triangle" style={{ marginRight: '5px' }}></i>
                                        <label style={{ color: '#757575' }}>Servicio con costo adicional. </label><a href={`https://wa.me/${customerServiceNumber}?text=${whatsappPurchaseText}`} target="_blank" style={{ textDecoration: 'underline', color: '#01717C', fontFamily: 'sans-serif', fontStyle: 'italic' }}>Contratar ahora</a>
                                    </small>
                                )}

                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                                    <Button
                                        icon={<Icon icon='bi:envelope' style={{ color: '#3CB8BA', marginRight: '10px', fontSize: '18px' }} />}
                                        label={"A " + (usedefaultcontact ? defaultEmail : (selectedPatient?.email ? selectedPatient.email : ''))}
                                        className='font-size-sendButton'
                                        onClick={() => { sendDigitalRP(EMessageType.EMAIL) }}
                                        style={{ backgroundColor: '#FFFFFF', color: '#292929', textAlign: 'left', flexGrow: 1, borderColor: '#3CB8BA' }}
                                        disabled={disabledEmail || !selectedPatient?.email || notPrescriptionInEffect()}
                                    />
                                    <Button
                                        icon={<Icon icon={selectedPatient?.email ? 'bi:pencil-square' : 'bi:plus'} style={{ color: '#01717C', fontSize: selectedPatient?.email ? '19px' : '24px' }} />}
                                        onClick={handleOpenEditMailModal}
                                        style={{ backgroundColor: '#FFFFFF', color: '#01717C', borderColor: '#3CB8BA', borderRadius: '4px', marginLeft: '10px', padding: '6px 1px', display: 'flex', alignItems: 'center', justifyContent: 'center', minWidth: '40px' }}
                                        disabled={disabledEmail || usedefaultcontact}
                                    />
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <Button
                                        icon={<Icon icon='bi:download' style={{ color: '#3CB8BA', marginRight: '10px', fontSize: '18px' }} />}
                                        label={"Descargar receta"}
                                        className='font-size-sendButton'
                                        onClick={handleDownloadPdfs}
                                        style={{ backgroundColor: '#FFFFFF', color: '#292929', textAlign: 'left', marginBottom: '10px', borderColor: '#3CB8BA' }}
                                        disabled={notPrescriptionInEffect()}
                                    />
                                    <Button
                                        icon={<Icon icon='bi:send' style={{ color: '#3CB8BA', marginRight: '10px', fontSize: '18px' }} />}
                                        label={"Compartir por otros medios"}
                                        className='font-size-sendButton'
                                        onClick={() => { handleShare() }}
                                        style={{ backgroundColor: '#FFFFFF', color: '#292929', textAlign: 'left', marginBottom: '30px', borderColor: '#3CB8BA' }}
                                        disabled={notPrescriptionInEffect()}
                                    />
                                </div>

                                <Button
                                    label="Cancelar"
                                    onClick={() => { setCancelModalVisible(true) }}
                                    style={{ marginBottom: '15px', backgroundColor: '#E8EBEF', color: '#1E1E1E', border: 'none', height: '36px' }}
                                />
                            </div>
                        </div>
                    </Modal>

                    <Modal
                        visible={openEditMobilephoneModal}
                        setVisible={setOpenEditMobilephoneModal}
                        header={<div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center', paddingTop: paddingTop, paddingLeft: '10%' }}>
                            <strong>{selectedPatient?.mobilephone ? "Editar celular del paciente" : "Ingresar celular del paciente"}</strong>
                        </div>}
                        headerStyle={{ fontSize: '12px', textAlign: 'center' }}
                        className='h-full'
                    >
                        <div className='recipe-history-view' style={{ display: 'flex', flexDirection: 'column' }}>
                            <label style={{ color: '#1E1E1E', fontSize: '14px' }}>Celular</label>
                            <InputPhone
                                cboClassname='border2 w-4'
                                inputClassname='border2'
                                value={patientPhone}
                                label="Característica sin 0 y número sin 15. (Ejemplo: 2231234567)"
                                floatLabel={false}
                                setValue={(mobile) => {
                                    setPatientPhone(mobile);
                                    setNewMobilephone(mobilePhoneToString(mobile));
                                }}
                            />
                            <Button
                                label="Agregar"
                                onClick={() => {
                                    const validation = validateInternationalCellphone(newMobilephone);
                                    if (!validation.isValid()) {
                                        showMessage(toast, validation.errorMessage, 'error');
                                        return;
                                    }
                                    if (selectedPatient) {
                                        setSelectedPatient({ ...selectedPatient, mobilephone: newMobilephone.replace(/[^+\d]/g, '') })
                                        savePatient({ ...selectedPatient, mobilephone: newMobilephone }, 0, 0)
                                            .then(() => {
                                                showMessage(toast, 'Datos guardados', 'success')
                                            })
                                            .catch(error => {
                                                showMessage(toast, 'Error al guardar el celular', 'error')
                                            });
                                        setOpenEditMobilephoneModal(false)
                                    }
                                }}
                                style={{ marginTop: '8px', backgroundColor: (newMobilephone?.trim() !== '' && !/^[A-Za-z]+$/.test(newMobilephone)) ? '#14C7BC' : '#9E9E9E', border: 'none' }}
                                disabled={newMobilephone?.trim() === '' || /^[A-Za-z]+$/.test(newMobilephone)}
                            />
                        </div>
                    </Modal>

                    <Modal
                        visible={openEditMailModal}
                        setVisible={setOpenEditMailModal}
                        header={<div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center', paddingTop: paddingTop, paddingLeft: '10%' }}>
                            <strong>{selectedPatient?.email ? "Editar mail del paciente" : "Ingresar mail del paciente"}</strong>
                        </div>}
                        headerStyle={{ fontSize: '12px', textAlign: 'center' }}
                        className='h-full'
                    >
                        <div className='recipe-history-view' style={{ display: 'flex', flexDirection: 'column' }}>
                            <label style={{ color: '#1E1E1E', fontSize: '14px' }}>Mail</label>
                            <InputTextCustom
                                className="border2"
                                name="email"
                                value={newMail}
                                onChange={(e: any) => {
                                    setNewMail(e.target.value);
                                }}
                            />
                            <Button
                                label="Agregar"
                                onClick={() => {
                                    if (selectedPatient) {
                                        setSelectedPatient({ ...selectedPatient, email: newMail })
                                        savePatient({ ...selectedPatient, email: newMail }, 0, 0)
                                            .then(() => {
                                                showMessage(toast, 'Se guardó el mail', 'success')
                                            })
                                            .catch(error => {
                                                showMessage(toast, 'Error al guardar el mail', 'error')
                                            });
                                        setOpenEditMailModal(false)
                                    }
                                }}
                                style={{ marginTop: '8px', backgroundColor: newMail?.trim() !== '' ? '#14C7BC' : '#9E9E9E', border: 'none' }}
                                disabled={newMail?.trim() === ''}
                            />
                        </div>
                    </Modal>
                </div>
                :
                <div>
                    <Modal
                        visible={sendModalVisible}
                        setVisible={setSendModalVisible}
                        header={
                            <label style={{ fontSize: '22px', color: '#B67345' }}>
                                {notPrescriptionInEffect() ? 'Receta vencida' : 'Receta realizada'}
                            </label>}
                        headerStyle={{ paddingTop: '3px' }}
                        className="h-full"
                        closable={false}
                        width='w-2xlarge'
                    >
                        <div className="modal-body" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', overflowX: 'scroll', overflowY: 'hidden' }}>
                            <div style={{ flex: '1', marginRight: '2rem' }}>
                                <PdfViewer fileList={[digitalRpFiles?.encodedPdf ?? '']} />
                            </div>
                            <div style={{ flex: '1', display: 'flex', flexDirection: 'column', borderLeft: '4px solid rgba(28, 50, 79, 0.38)', paddingLeft: '1rem', paddingRight: '1rem', minWidth: 'fit-content', marginTop: '20px' }}>
                                {notPrescriptionInEffect() && (
                                    <div
                                        style={{
                                            fontSize: '16px',
                                            color: 'rgb(30, 30, 30)',
                                            marginBottom: '1rem',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            lineHeight: '1.5',
                                        }}>
                                        <span style={{ fontWeight: 'bold' }}>
                                            Esta receta médica se encuentra vencida.
                                        </span>
                                        <span style={{ color: 'rgba(30,30,30,0.8)', fontWeight: 'normal' }}>
                                            Podés repetirla o generar una nueva para continuar con el proceso.
                                        </span>
                                    </div>
                                )}
                                <Button
                                    label={"Repetir"}
                                    className='font-size-sendButton btnRpBack'
                                    onClick={() => {
                                        if (digitalRpId)
                                            copyDigitalRpById(digitalRpId)
                                                .then((res) => {
                                                    setMedications(res.medications)
                                                    setProlongedTreatment(res.prolongedtreatment ? res.prolongedtreatment : false)
                                                    setHidePatientData(res.hidepatientdata ? res.hidepatientdata : false)

                                                    setPrevSubActiveView(ERecipeHistoryTab.FINISHED)
                                                    setPrevActiveView(activeView)

                                                    setSubActiveView(ESteps.MEDICATIONSTEP)
                                                    setActiveView(ERecipeViews.NEWRECIPE)
                                                })
                                        else
                                            console.error('digitalRpId undefined')
                                    }}
                                    style={{ backgroundColor: '#FFFFFF', color: '#292929', marginBottom: '10px', borderColor: '#3CB8BA', marginTop: '20px' }}
                                    disabled={!allProfileDataFilled}
                                />
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                                    <Button
                                        icon={<Icon icon='bi:chat' style={{ color: disabledWhatsapp ? '#A8A8A8' : '#3CB8BA', marginRight: '10px', fontSize: '18px' }} />}
                                        label={"Por whatsapp a " + (usedefaultcontact ? defaultMobilePhone : (selectedPatient?.mobilephone ? selectedPatient.mobilephone : ''))}
                                        className='font-size-sendButton btnRpBack'
                                        onClick={() => { sendDigitalRP(EMessageType.WHATSAPP) }}
                                        style={{ backgroundColor: '#FFFFFF', color: '#292929', textAlign: 'left', flexGrow: 1, borderColor: '#3CB8BA', minWidth: 'fit-content' }}
                                        disabled={disabledWhatsapp || !selectedPatient?.mobilephone || notPrescriptionInEffect()}
                                    />
                                    <Button
                                        className='btnRpBack'
                                        icon={<Icon icon={selectedPatient?.mobilephone ? 'bi:pencil-square' : 'bi:plus'} style={{ color: '#01717C', fontSize: selectedPatient?.mobilephone ? '19px' : '24px' }} />}
                                        onClick={handleOpenEditMobilephoneModal}
                                        style={{ backgroundColor: '#FFFFFF', color: '#01717C', borderColor: '#3CB8BA', borderRadius: '4px', marginLeft: '10px', padding: '6px 1px', display: 'flex', alignItems: 'center', justifyContent: 'center', minWidth: '40px' }}
                                        disabled={disabledWhatsapp || usedefaultcontact}
                                    />
                                </div>
                                {disabledWhatsapp && (
                                    <small style={{ color: '#FFB400', display: 'block', marginTop: '-5px', marginBottom: '5px', textAlign: 'right' }}>
                                        <i className="pi pi-exclamation-triangle" style={{ marginRight: '5px' }}></i>
                                        <label style={{ color: '#757575' }}>Servicio con costo adicional. </label><a href={`https://wa.me/${customerServiceNumber}?text=${whatsappPurchaseText}`} target="_blank" style={{ textDecoration: 'underline', color: '#01717C', fontFamily: 'sans-serif', fontStyle: 'italic' }}>Contratar ahora</a>
                                    </small>
                                )}

                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                                    <Button
                                        icon={<Icon icon='bi:envelope' style={{ color: '#3CB8BA', marginRight: '10px', fontSize: '18px' }} />}
                                        label={"A " + (usedefaultcontact ? defaultEmail : (selectedPatient?.email ? selectedPatient.email : ''))}
                                        className='font-size-sendButton btnRpBack'
                                        onClick={() => { sendDigitalRP(EMessageType.EMAIL) }}
                                        style={{ backgroundColor: '#FFFFFF', color: '#292929', textAlign: 'left', flexGrow: 1, borderColor: '#3CB8BA', minWidth: 'fit-content' }}
                                        disabled={disabledEmail || !selectedPatient?.email || notPrescriptionInEffect()}
                                    />
                                    <Button
                                        className='btnRpBack'
                                        icon={<Icon icon={selectedPatient?.email ? 'bi:pencil-square' : 'bi:plus'} style={{ color: '#01717C', fontSize: selectedPatient?.email ? '19px' : '24px' }} />}
                                        onClick={handleOpenEditMailModal}
                                        style={{ backgroundColor: '#FFFFFF', color: '#01717C', borderColor: '#3CB8BA', borderRadius: '4px', marginLeft: '10px', padding: '6px 1px', display: 'flex', alignItems: 'center', justifyContent: 'center', minWidth: '40px' }}
                                        disabled={disabledEmail || usedefaultcontact}
                                    />
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <Button
                                        icon={<Icon icon='bi:download' style={{ color: '#3CB8BA', marginRight: '10px', fontSize: '18px' }} />}
                                        label={"Descargar receta"}
                                        className='font-size-sendButton btnRpBack'
                                        onClick={handleDownloadPdfs}
                                        style={{ backgroundColor: '#FFFFFF', color: '#292929', textAlign: 'left', marginBottom: '10px', borderColor: '#3CB8BA' }}
                                        disabled={notPrescriptionInEffect()}
                                    />
                                    <Button
                                        icon={<Icon icon='bi:send' style={{ color: '#3CB8BA', marginRight: '10px', fontSize: '18px' }} />}
                                        label={"Compartir por otros medios"}
                                        className='font-size-sendButton btnRpBack'
                                        onClick={() => { handleShare() }}
                                        style={{ backgroundColor: '#FFFFFF', color: '#292929', textAlign: 'left', marginBottom: '30px', borderColor: '#3CB8BA' }}
                                        disabled={notPrescriptionInEffect()}
                                    />
                                </div>

                                <Button
                                    className='btnRpBack'
                                    label="Cancelar"
                                    onClick={() => { setCancelModalVisible(true) }}
                                    style={{ marginBottom: '15px', backgroundColor: '#E8EBEF', color: '#1E1E1E', border: 'none', height: '36px' }}
                                />
                            </div>
                        </div>
                    </Modal>

                    <Modal
                        visible={openEditMobilephoneModal}
                        setVisible={setOpenEditMobilephoneModal}
                        header={<div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
                            <strong>{selectedPatient?.mobilephone ? "Editar celular del paciente" : "Ingresar celular del paciente"}</strong>
                        </div>}
                        headerStyle={{ fontSize: '12px', textAlign: 'center' }}
                        width='w-medium'
                    >
                        <div className='recipe-history-view' style={{ display: 'flex', flexDirection: 'column' }}>
                            <label style={{ color: '#1E1E1E', fontSize: '14px' }}>Celular</label>
                            <InputPhone
                                cboClassname='border2 w-4'
                                inputClassname='border2'
                                value={patientPhone}
                                label="Característica sin 0 y número sin 15. (Ejemplo: 2231234567)"
                                floatLabel={false}
                                setValue={(mobile) => {
                                    setPatientPhone(mobile);
                                    setNewMobilephone(mobilePhoneToString(mobile));
                                }}
                            />
                            <Button
                                label="Agregar"
                                onClick={() => {
                                    const validation = validateInternationalCellphone(newMobilephone);
                                    if (!validation.isValid()) {
                                        showMessage(toast, validation.errorMessage, 'error');
                                        return;
                                    }
                                    if (selectedPatient) {
                                        setSelectedPatient({ ...selectedPatient, mobilephone: newMobilephone.replace(/[^+\d]/g, '') })
                                        savePatient({ ...selectedPatient, mobilephone: newMobilephone }, 0, 0)
                                            .then(() => {
                                                showMessage(toast, 'Datos guardados', 'success')
                                            })
                                            .catch(error => {
                                                showMessage(toast, 'Error al guardar el celular', 'error')
                                            });
                                        setOpenEditMobilephoneModal(false)
                                    }
                                }}
                                style={{ marginTop: '8px', backgroundColor: (newMobilephone?.trim() !== '' && !/^[A-Za-z]+$/.test(newMobilephone)) ? '#14C7BC' : '#9E9E9E', border: 'none' }}
                                disabled={newMobilephone?.trim() === '' || /^[A-Za-z]+$/.test(newMobilephone)}
                            />
                        </div>
                    </Modal>

                    <Modal
                        visible={openEditMailModal}
                        setVisible={setOpenEditMailModal}
                        header={<div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
                            <strong>{selectedPatient?.email ? "Editar mail del paciente" : "Ingresar mail del paciente"}</strong>
                        </div>}
                        headerStyle={{ fontSize: '12px', textAlign: 'center' }}
                        width='w-medium'
                    >
                        <div className='recipe-history-view' style={{ display: 'flex', flexDirection: 'column' }}>
                            <label style={{ color: '#1E1E1E', fontSize: '14px' }}>Mail</label>
                            <InputTextCustom
                                className="border2"
                                name="email"
                                value={newMail}
                                onChange={(e: any) => {
                                    setNewMail(e.target.value);
                                }}
                            />
                            <Button
                                label="Agregar"
                                onClick={() => {
                                    if (selectedPatient) {
                                        setSelectedPatient({ ...selectedPatient, email: newMail })
                                        savePatient({ ...selectedPatient, email: newMail }, 0, 0)
                                            .then(() => {
                                                showMessage(toast, 'Se guardó el mail', 'success')
                                            })
                                            .catch(error => {
                                                showMessage(toast, 'Error al guardar el mail', 'error')
                                            });
                                        setOpenEditMailModal(false)
                                    }
                                }}
                                style={{ marginTop: '8px', backgroundColor: newMail?.trim() !== '' ? '#14C7BC' : '#9E9E9E', border: 'none' }}
                                disabled={newMail?.trim() === ''}
                            />
                        </div>
                    </Modal>
                </div>
            }

            <Modal
                visible={cancelModalVisible}
                setVisible={setCancelModalVisible}
                header={<label><strong>¿Querés cancelar el envío de esta receta?</strong></label>}
                headerStyle={{ fontSize: '12px', textAlign: 'center', paddingTop: paddingTop }}
                closable={false}
                className='h-full'
            >
                <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column' }}>
                    <Button
                        label="No, quiero enviar la receta"
                        onClick={() => setCancelModalVisible(false)}
                        style={{ backgroundColor: '#FFFFFF', color: '#545454', border: '1px solid #3CB8BA', marginBottom: '15px', }}
                    />
                    <Button
                        label="Sí, salir sin enviar"
                        onClick={() => { setSendModalVisible(false), setCancelModalVisible(false) }}  //te debe llevar al dashboard
                        style={{ backgroundColor: '#14C7BC', border: 'none' }}
                    />
                </div>
            </Modal>

            <Toast ref={toast} onRemove={handleRemoveToast} position='top-right' /> {/*onRemove hace algo, en el momento que el toast se cierra (tanto despues de pasar un tiempo como por cerrarlo manualmente)*/}
            <WindowLoader showLoader={loading} className='whiteSpinner' />
        </div>
    );
}
